import React from "react";
import { Icon } from "@evertrue/et-components";
import CDCUtilsContext from "../contexts/cdc-dependencies-context";

const renderStatusMessage = (status, isVMSApp = false) => {
  if (status === "success" && !isVMSApp) {
    return (
      <div className="cdc-status--success">
        <Icon icon="check-circle" size={2} />
        <div className="cdc-status-message">
          <p className="cdc-status--header">Suggestion Sent</p>
          <p>
            We’ve sent your suggestion to your organization’s data manager. Changes will be reflected once your
            suggestion is approved and the new data is imported into EverTrue.
          </p>
        </div>
      </div>
    );
  } else if (status === "error") {
    return (
      <div className="cdc-status--error">
        <Icon icon="alert-circle" size={2} />
        <div className="cdc-status-message">
          <p className="cdc-status--header">Suggestion failed</p>
          <p>Something went wrong on our end. Please try again later.</p>
        </div>
      </div>
    );
  }
  return null;
};

const CDCStatus = ({ status }) => {
  const { isVMSApp } = React.useContext(CDCUtilsContext);
  return renderStatusMessage(status, isVMSApp);
};

export default CDCStatus;
